<template>
    <div class="navContent s_bf2">
      <div class="navItem" v-for="(v,k) in data.data" :key="k">
        <img :src="v.imgUrl?v.imgUrl.indexOf('http')!=-1?v.imgUrl:info.picdomain+v.imgUrl:require('@/assets/images/normal.png')" alt="" style="width:40px;height:40px">
        <p class="m-t-5">{{v.name}}</p>
      </div>

    </div>
</template>
<script>
import config from '@/config'
import store from '@/store'
export default {
    props: { data: Object },
    setup(){
      return{
        assetsOss:config.oss[process.env.VUE_APP_type],
        info: store.state.user.info,
      }
    }
}
</script>
<style lang="less" scoped>
.navContent {
  display: flex;
  flex-wrap: wrap;
  padding:10px;
  width: 100%;
  .navItem{
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 24upx;
    color: #8e8e8e;
    img{
      width: 72upx;
      height: 72upx;
    }
  }
}
</style>